<div #spinner>
  <div class="shade"></div>
  <ngx-loading-bar></ngx-loading-bar>
</div>
